package com.ustadmobile.core.viewmodel.errors

class ErrorViewModel {

    companion object {

        const val DEST_NAME = "Error"
    }
}